module.exports = __webpack_public_path__ + "img/portrait-057.439f5da4.jpg";